module.exports = __webpack_public_path__ + "media/images/pic/hero/hero-af22c39adcdf3efca48722fa6f092b05.webp";